import * as Order from './order';

export enum Status {
  Pending = 'PENDING',
  SubmittingToEhr = 'SUBMITTING_TO_EHR',
  SubmittedToEhr = 'SUBMITTED_TO_EHR',
  NeedsManualSubmit = 'NEEDS_MANUAL_SUBMIT',
}
export interface EncounterProblem {
  encounterId: string;
  problem: string;
  icd10s: string[];
  orders: Order.Order[];
  status: Status;
}
